import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "iconfont icon-v-add"
}

import { computed, reactive, toRefs,getCurrentInstance } from "vue";
import FetchRequest from "@/api/FetchRequest";
import Auth from "@/api/Auth";
import Avatar from "@/components/Avatar.vue";
import { uploadFileCommon } from '@/components/common/fileTypeUpload.ts';
interface VimData {
  host: string;
  headers: any;
  data: any;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AvatarUpload',
  props: {
  avatar: {
    type: String,
    required: true,
    default: "/img/default-group.png",
  },
},
  emits: ["uploadSuccess"],
  setup(__props, { emit: __emit }) {

let { proxy } = getCurrentInstance()
const props = __props;

let avatar = computed(() => {
  return props.avatar;
});
const token = Auth.getToken();

const vimData = reactive<VimData>({
  host: FetchRequest.getHost(),
  headers: {
    "Access-Control-Allow-Origin": "*",
    Authorization: "Bearer " + token,
  },
  data: {
    access_token: Auth.getToken(),
    type: "file",
  },
});
const emits = __emit;
//上传成功回调
const handleSuccess = (response: any) => {
  console.log(response)
  // emits("uploadSuccess", response.url);
  // emits("uploadSuccess", response.fileName)
  emits("uploadSuccess", response.msg)
  
};
const uploadFileCommonFun = (file: any) => {
   
    uploadFileCommon(file, 'avatar',0).then((res: any) => {
        if(res.code==200){
             emits("uploadSuccess", res.data.url)
        }
        
    });
};
const { host, headers, data } = toRefs(vimData);

return (_ctx: any,_cache: any) => {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, {
    "show-file-list": false,
    multiple: "",
    "auto-upload": false,
    onChange: uploadFileCommonFun
  }, {
    default: _withCtx(() => [
      (_unref(avatar))
        ? (_openBlock(), _createBlock(Avatar, {
            key: 0,
            size: "large",
            img: _unref(proxy).getimgUrl+ _unref(avatar)
          }, null, 8, ["img"]))
        : _createCommentVNode("", true),
      (!_unref(avatar))
        ? (_openBlock(), _createElementBlock("i", _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})